import type { TemplateStatusInfo, RepublishActionData } from '~/modules/campaign-template';

import { RepublishTemplateItem } from './RepublishTemplateItem';
import { ReplaceTemplateItem } from './ReplaceTemplateItem';
import { useTranslation } from 'react-i18next';
import { List, Text } from '@shopify/polaris';

interface CombinedTemplateContentProps {
  unpublishedTemplates: TemplateStatusInfo[];
  deletedTemplates: TemplateStatusInfo[];
  isBannerInCard?: boolean;
  isDetailsScreen?: boolean;
  onRepublish: (data: RepublishActionData) => void;
  onEditCampaign: () => void;
}

export const CombinedTemplateContent = ({
  unpublishedTemplates,
  deletedTemplates,
  isBannerInCard,
  isDetailsScreen,
  onRepublish,
  onEditCampaign,
}: CombinedTemplateContentProps) => {
  const { t } = useTranslation();

  const getTitle = () => {
    const subtitle = t('Please follow these steps to ensure the experiment runs normally:');
    if (isBannerInCard)
      return t('This experiment has unpublished and deleted template. {{subtitle}}', { subtitle });

    return subtitle;
  };

  return (
    <>
      <Text as="p" variant="bodyMd">
        {getTitle()}
      </Text>
      <List gap="extraTight">
        {unpublishedTemplates.map(({ name, variant, campaign }) => (
          <RepublishTemplateItem
            key={variant.id}
            name={name}
            onRepublish={() => onRepublish({ campaign, variant })}
          />
        ))}
        {deletedTemplates.map(({ name }) => (
          <ReplaceTemplateItem
            key={name}
            name={name}
            onEditCampaign={onEditCampaign}
            isDetailsScreen={isDetailsScreen}
          />
        ))}
      </List>
    </>
  );
};
